import { render, staticRenderFns } from "./orderextendlist.vue?vue&type=template&id=659275ff&scoped=true"
import script from "./orderextendlist.vue?vue&type=script&lang=js"
export * from "./orderextendlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659275ff",
  null
  
)

export default component.exports